import React from 'react';
import { Box } from '@podiumhq/design-system';
import FakeConversationList from './FakeConversationList';
import FakeConversation from './FakeConversation';
import FakeNavBar from './FakeNavBar';
import FakeSideNav from './FakeSideNav';

const FakeApp = ({ blur = '0', opacity = '.5' }) => {
  return (
    <Box display={{ base: 'none', md: 'block' }}>
      <Box
        position="fixed"
        width="100%"
        zIndex="1"
        background="grey.base"
        opacity={opacity}
        height="100%"
        sx={{
          '-webkit-touch-callout': 'none',
          '-webkit-user-select': 'none',
          '-moz-user-select': 'none',
          '-ms-user-select': 'none',
          'user-select': 'none',
        }}
      />
      <Box overflow="hidden" zIndex="-1" filter={`blur(${blur})`}>
        <FakeNavBar />
        <Box
          height="calc(100vh - 56px)"
          flexBasis="calc(100vh - 56px)"
          display="flex"
          width="100%"
          minHeight="0"
          flex="0"
          marginRight="auto"
          marginLeft="auto"
        >
          <FakeSideNav />

          <Box
            backgroundColor="white"
            flexGrow="1"
            display="flex"
            height="100%"
            width="100%"
          >
            <FakeConversationList />
            <FakeConversation />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FakeApp;
